import React, { useState } from "react";
import { connect } from "react-redux";
import {
  userLoginReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./Login.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import Login from "../../library/Login/Login";
import { modalType, profiles } from "../../../modules/constants";
import { useTranslation } from "react-i18next";

export const SmartLogin = (props) => {
  const {
    setOpenAuthModal,
    login,
    closeModalGoHome,
    loginUsername,
    setLoginUsername,
    openOnSecondStep,
  } = props;

  const { t } = useTranslation();

  const [errorMessage, setErrorMessage] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const submitHandler = (username, password) => {
    if (username && password) {
      setButtonDisabled(true);
      login({ username, password })
        .then((res) => {
          if (res?.passwordToken) {
            setOpenAuthModal(
              modalType.changePassword,
              t("appText.changePassword.title")
            );
          } else if (
            res?.acceptedTermsAndConditions === false &&
            res?.decryptedRole === profiles.participant
          ) {
            setOpenAuthModal(
              modalType.notice,
              t("appText.privacyPolicy.notice.title")
            );
          } else {
            closeModalGoHome();
          }
          setLoginUsername("");
        })
        .catch((err) => {
          setButtonDisabled(false);
          setErrorMessage(err);
        });
    } else {
      if (!username && !password) {
        setErrorMessage(t("errorText.auth.login.empty.credentials"));
      } else if (!username && password) {
        setErrorMessage(t("errorText.auth.login.empty.emailOrCaregiverID"));
      } else if (username && !password) {
        setErrorMessage(t("errorText.auth.login.empty.password"));
      }
    }
  };

  const forgotPasswordHandler = () => {
    setOpenAuthModal(
      modalType.recoverPassword,
      t("appText.passwordRecovery.title")
    );
  };

  return (
    <Login
      onSubmit={submitHandler}
      errorMessage={errorMessage}
      setErrorMessage={setErrorMessage}
      onForgotPassword={forgotPasswordHandler}
      buttonDisabled={buttonDisabled}
      username={loginUsername}
      setUsername={setLoginUsername}
      openOnSecondStep={openOnSecondStep}
    />
  );
};

export default dynamic(
  "userLoginReducer",
  subspaced({
    mapExtraState: (state) => {
      return {
        loginReducer: state.loginReducer,
      };
    },
  }),
  attachReducer(userLoginReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartLogin));
